export enum RequestMethods {
  post = 'post',
  get = 'get',
}
